/*global google*/
import React, { useState } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import home from "../../assets/icons/home.svg";
import { Form } from "react-bootstrap";
import { Element } from "react-scroll";
import { getClasses } from "../../helpers/getClasses";
import { useProductInput } from "../../hooks";
import { useFormContext, useWatch } from "react-hook-form";
import { useTravelZone } from "../../context/TravelZoneContext";

const Map = (props) => {
  const { fieldProps, fieldState } = useProductInput({
    required: "Please mark the location on the map!!",
    ...props,
  });
  const { error, invalid } = fieldState;
  const markerPosition = useWatch({ name: "address_info.latlng" });
  const { setValue } = useFormContext();
  const { setTravelZone } = useTravelZone();
  const [initial_position] = useState(
    markerPosition || { lat: 48.4383913, lng: -123.3699032 }
  );

  const handleMoveMarker = (e) => {
    setValue("address_info.latlng", e.latLng.toJSON());
    setTravelZone(e.latLng);
  };
  return (
    <Form.Group as={Element} name="map">
      <GoogleMap
        ref={fieldProps.ref}
        id="map"
        mapContainerClassName={getClasses([
          invalid && "is-invalid",
          "map-container",
        ])}
        mapContainerStyle={{
          height: "600px",
          maxHeight: "60vh",
          width: "100%",
        }}
        options={{
          streetViewControl: false,
          fullscreenControl: false,
          gestureHandling: "cooperative",
        }}
        zoom={16}
        center={initial_position}
        onClick={handleMoveMarker}
      >
        {markerPosition && (
          <Marker
            position={markerPosition}
            icon={{
              url: home,
              anchor: new google.maps.Point(22.5, 17.5),
            }}
            draggable={true}
            onDragEnd={handleMoveMarker}
            clickable={false}
          />
        )}
      </GoogleMap>
      <Form.Control.Feedback type="invalid">
        {error?.message}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
export default Map;
